$=jQuery;
function addLoadEvent(func) {
    var oldonload = window.onload;
    if (typeof window.onload != 'function') {
        window.onload = func;
    } else {
        window.onload = function () {
            oldonload();
            func();
        };
    }
}

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from 'swiper';
import "swiper/swiper-bundle.css";
import {Navigation,Pagination,Autoplay,Thumbs,Controller} from 'swiper/modules';





gsap.registerPlugin(ScrollTrigger);

jQuery(function ($) {


    // --- SHOWHIDE NAVBAR ---

    var didScroll;
    var lastScrollTop = 0;
    var delta = 120;
    var navbarHeight = 110;
    $(window).scroll(function () {
        didScroll = true;
    });
    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 350);
    function hasScrolled() {
        var st = $(this).scrollTop();
        if (Math.abs(lastScrollTop - st) <= delta)
            return;
        if (st > lastScrollTop && st > navbarHeight) {
            $('.nav-sticky').addClass('nav-up');
        } else {
            if (st + $(window).height() < $(document).height()) {
                $('.nav-sticky').removeClass('nav-up');
            }
        }
        lastScrollTop = st;
    }
    
    // --- NAV ---

    
    $(".nav-burger").click(function () {
        $(".burger").toggleClass("active");
        $(".nav-responsive").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    }); 

    $(".nav ul.menu > li.menu-item-has-children > a").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        
        var $this = $(this);
        var $parent = $this.parents("li").first();
        
        var $subMenu = $("ul.sub-menu", $parent);
        if($subMenu.is(":visible")) {
            $subMenu.hide();
        } else {
            $(".nav-active ul.menu li ul.sub-menu").hide();
            $subMenu.show();
        } 
    });
    
    $(".nav-responsive ul.menu > li.menu-item-has-children > a").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        
        var $this = $(this);
        var $parent = $this.parents("li").first();
        
        var $subMenu = $("ul.sub-menu", $parent);
        if($subMenu.is(":visible")) {
            $subMenu.hide();
        } else {
            $(".nav-active ul.menu li ul.sub-menu").hide();
            $subMenu.show();
        } 
    });
    
    $(".page-single article .gallery br").remove();  

    // --- BURGER ANIMATED ---
    
    $('#nav-burger-animated').click(function () {
        $(this).toggleClass('open');
    });

    // --- NOTICE ALERT ---
    
    $(".notice-alert-close").click(function () {
        $(".notice-alert").slideUp();
    });
    
    $(document.body).trigger('wc_fragment_refresh');


     

     /*-------- Swiper materiel 1 ---------*/

     var swiper = new Swiper(".swiper__materiel__1", {
        modules: [Navigation, Autoplay, Pagination],
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

      var swiper = new Swiper(".swiper__materiel__2", {
        modules: [Navigation, Autoplay, Pagination],
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });


      /*--------------------------  PAGE MATÉRIEL ---------------------------*/

        $(".materiel__container").click(function() {
            var materielId = $(this).data("materiel-id");
            var detailsContainer = $(".details__container[data-materiel-id='" + materielId + "']");
        
            // Ferme tous les autres détails sauf celui cliqué
            $(".details__container").not(detailsContainer).hide();
        
            // Toggle l'affichage du détail actuel
            detailsContainer.toggle();
        
            $('html, body').animate({
            scrollTop: $(detailsContainer).offset().top - 250
        }, 1000);
        });
        
        /*-------- Ferme la div "details__container"  ---------*/
        
        $(".section__materiel .details__container .close").click(function() {
            var detailsContainer = $(".details__container");
            detailsContainer.hide();
            console.log('click')
        });


        /*-------- Change la couleur du fond une fois sur deux  ---------*/
        var couleurCourante = "#f7f7f7";
        $(" .detail__container p").each(function() {
        if (couleurCourante === "#f7f7f7") {
            $(this).css("background-color", "#f7f7f7");
            couleurCourante = "#ffffff";
        } else {
            $(this).css("background-color", "#ffffff");
            couleurCourante = "#f7f7f7";
        }
        });

        $(" .caracteristique__container .content p").each(function() {
            if (couleurCourante === "#ffffff") {
                $(this).css("background-color", "#ffffff");
                couleurCourante = "#f7f7f7";
            } else {
                $(this).css("background-color", "#f7f7f7");
                couleurCourante = "#ffffff";
            }
            });

        var swiperMateriel = new Swiper(".swipper__materiel", {
            modules: [Navigation, Autoplay, Pagination],
            centeredSlides: true,
            /*autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },*/
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
            pagination: {
              el: ".swiper-pagination",
            },
          });
        
        /*
        var swipper__materiel1 = new Swiper(".swipper__materiel1", {
            loopedSlides: 10,
            centeredSlides: true,
            spaceBetween: 10,
            slideToClickedSlide: true,
            slidesPerView: 5,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            controller: {
              control: swipper__materiel2,
            },
           
          });
          
          var swipper__materiel2 = new Swiper(".swipper__materiel2", {
            modules: [Navigation, Autoplay, Pagination],
            loopedSlides: 10,
            spaceBetween: 10,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            controller: {
              control: swipper__materiel1,
            },
          });  */



          /*-------- Ouvre la div "detail__container"  ---------*/
        
       

        $(".button__detail").click(function() {
            // Utilise $(this) pour faire référence au bouton cliqué
            var contentContainer = $(this).closest('.detail__container').find(".content");
        
            // Supprime la classe 'active' de toutes les divs '.content' pour éviter les conflits
            //$(".detail__container .content").not(contentContainer).removeClass('active');

            // Vérifie si la div 'content' est visible
            var isVisible = contentContainer.is(":visible");

            // Change la source (src) de l'image en fonction de la visibilité de la div 'content'
            var imgSrc = isVisible ? "http://localhost:10124/wp-content/themes/Webpack/asset/src/img/svg/plus.svg"  : "http://localhost:10124/wp-content/themes/Webpack/asset/src/img/svg/moins.svg";

            // Change la source (src) de l'image uniquement pour le bouton cliqué
            $(this).attr("src", imgSrc);

            // Ajoute ou supprime la classe 'active' à la div 'content' associée au bouton cliqué
            contentContainer.toggleClass('active');

          
        });


        /*-------- Change la couleur du fond une fois sur deux pour la SECTION TRAITEMENT  ---------*/
        var couleur = "#ffffff";
        $(" .section__traitement ").each(function() {
        if (couleur === "#ffffff") {
            $(this).css("background-color", "#ffffff");
            couleur = "#F5F5F5";
        } else {
            $(this).css("background-color", "#F5F5F5");
            couleur = "#ffffff";
        }
        });

          
   


    

    
});

    
    

